import { useContext, createContext } from 'react';

import cn from 'classnames/bind';
import { useToggleState } from 'hooks';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';

import s from './Accordion.module.css';

const cx = cn.bind(s);

const Context = createContext({isOpened: true, disabled: true});

const Accordion = ({ children, initialIsOpen = false, disabled = false }) => {
  const { isActive: isOpened, toggle } = useToggleState(initialIsOpen);
  return (
    <Context.Provider value={{ isOpened, disabled, toggle }}>
      { typeof children === 'function' ? children({ isOpened }) : children }
    </Context.Provider>
  );
};

Accordion.propTypes = {
  initialIsOpen: PropTypes.bool,
  disabled: PropTypes.bool,
};

const AccordionHeader = ({ children, className }) => {
  const { isOpened, toggle, disabled } = useContext(Context);
  const onClick = () => {
    if (disabled) {
      return;
    }
    toggle();
  };
  return (
    <button type="button" className={cx('header', className, { disabled })} aria-expanded={String(isOpened)} onClick={onClick}>
      {typeof children === 'function' ? children(isOpened) : children}
    </button>
  );
};

const AccordionContent = ({ children }) => {
  const { isOpened } = useContext(Context);

  return (
    <AnimateHeight height={isOpened ? 'auto' : 0} className="accordion-content">
      { children }
    </AnimateHeight>
  );
};

Accordion.Header = AccordionHeader;
Accordion.Content = AccordionContent;

export default Accordion;
